/* ==========================================================================
   <product-recommendations> — fetches Shopify's native recommendation
   endpoint and injects the rendered section HTML.
   ========================================================================== */
(function () {
  'use strict';

  function ProductRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var content = temp.querySelector('.product-recommendations');
        if (content) {
          el.innerHTML = '';
          el.appendChild(content);
        }
      })
      .catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('product-recommendations:not([data-initialized])').forEach(function (el) {
      el.setAttribute('data-initialized', 'true');
      ProductRecommendations(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
